import { CAMPSITES_DATA_SYNC_JOB_TRIGGER } from "@/modules/jobs/store/mutations-types"

const mutations = {
  [CAMPSITES_DATA_SYNC_JOB_TRIGGER](state, payload) {
    state.dataJobTrigger = payload
  },
}

export default mutations
